var CasePracticeAnimationModule = (function () {
    function CasePracticeAnimationModule() {
    }
    return CasePracticeAnimationModule;
}());
export { CasePracticeAnimationModule };



// WEBPACK FOOTER //
// ./src/app/case-practice-animation/case-practice-animation.module.ts.pre-build-optimizer.js